import { Component, computed, inject, input, resource, signal } from '@angular/core';
import { SwitchBar, SwitchBarOption } from 'excellence-ui';
import { NgIcon } from '@ng-icons/core';
import { Api } from '../../../../core/clients/omni-core/api';
import { getConsumptionByYear } from '../../../../core/clients/omni-core/functions';
import { GermanNumberPipe } from '../../../../shared/pipes/german-number-pipe';
import { form, FormField } from '@angular/forms/signals';
import { ResponsiveValue } from '../../../../shared/components/responsive-value/responsive-value';
import { ErrorComponent } from '../../../../shared/components/error-component/error-component';
import { TranslocoPipe } from '@jsverse/transloco';
import { NgClass } from '@angular/common';
import { DashboardSummaryCardSkeleton } from '../dashboard-summary-card-skeleton/dashboard-summary-card-skeleton';

@Component({
  selector: 'app-dashboard-consumption-summary-card',
  imports: [
    SwitchBar,
    SwitchBarOption,
    NgIcon,
    GermanNumberPipe,
    FormField,
    ResponsiveValue,
    ErrorComponent,
    TranslocoPipe,
    NgClass,
    DashboardSummaryCardSkeleton,
  ],
  templateUrl: './dashboard-consumption-summary-card.html',
})
export class DashboardConsumptionSummaryCard {
  private api = inject(Api);

  organizationId = input.required<string>();
  year = input.required<number>();

  protected consumption = resource({
    params: () => ({
      id: this.organizationId(),
      year: this.year(),
    }),
    loader: async ({ params }) => this.api.invoke(getConsumptionByYear, params),
  });

  private settings = signal<{ utilityType: 'ELECTRICITY' | 'GAS' }>({
    utilityType: 'ELECTRICITY',
  });
  protected settingsForm = form(this.settings);

  protected consumptionValue = computed(() => {
    const value = this.consumption.hasValue() ? this.consumption.value() : null;
    switch (this.settings().utilityType) {
      case 'ELECTRICITY':
        return value?.electricity ?? 0;
      case 'GAS':
        return value?.gas ?? 0;
    }
  });
}
